import React from "react";
import EditGeneralInfo from "./EditGeneralInfo";
import EditExternalRMSInfo from "./EditExternalRMSInfo";
import EditOutOfService from "./EditOutOfService";
import EditStorageInformation from "./EditStorageInformation";

function EditAedForm({
  AccountList,
  BrandList,
  formData,
  setFormData,
  setPermission,
  Permissins,
  RmsDropdown,
  all_condition_true,
  is_edit = false,
  DefaultValue,
  aedList,
  loanerList,
  setAccId,
  AccId,
  siteId
}) {
  return (
    <>
      <div className="">
        <EditGeneralInfo
          BrandList={BrandList}
          AccountList={AccountList}
          formData={formData}
          setFormData={setFormData}
          setPermission={setPermission}
          Permissins={Permissins}
          is_edit={is_edit}
          DefaultValue={DefaultValue}
          setAccId={setAccId}
          AccId={AccId}
        />
        {formData?.RMS_toggle || all_condition_true ? (
          <EditExternalRMSInfo
            BrandList={BrandList}
            AccountList={AccountList}
            formData={formData}
            setFormData={setFormData}
            RmsDropdown={RmsDropdown}
          />
        ) : (
          ""
        )}

        {formData?.out_of_service_toggle || all_condition_true ? (
          <EditOutOfService
            BrandList={BrandList}
            AccountList={AccountList}
            formData={formData}
            setFormData={setFormData}
            aedList={aedList}
            loanerList={loanerList}
            siteId={siteId}
          />
        ) : (
          ""
        )}

        <EditStorageInformation
          BrandList={BrandList}
          AccountList={AccountList}
          formData={formData}
          setFormData={setFormData}
          keyName={"keyName"}
          Permissins={Permissins}
        />
      </div>
    </>
  );
}

export default EditAedForm;
